export default __webpack_public_path__ + "assets/images/Dashboard Menu Icon-c4b77e3948f675cbe4e6f1a449307437.svg";